var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-card shadow bg-white rounded-lg d-flex flex-column align-items-center justify-content-between p-3 mx-3 mx-sm-0"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }